<template>
	<el-dialog :title="title" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
		<el-form ref="form" :model="form" label-width="80px">
			<el-form-item label="标题">
				<el-input :disabled="isOnlyRead" v-model="form.title"></el-input>
			</el-form-item>
			<el-form-item label="内容">
				<el-input :disabled="isOnlyRead" type="textarea" v-model="form.content"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button :disabled="isOnlyRead" @click="selectVisible = true">选择素材</el-button>
				<div v-for="(item,index) in selection" :key="index" class="item1">
					<span>{{item.filename}}</span>
					<span style="cursor: pointer;" @click="handleDelete(item)"><el-icon
							class="el-icon-circle-close"></el-icon></span>
				</div>
			</el-form-item>
			<el-form-item v-if="!isOnlyRead">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</el-form-item>
		</el-form>
		<selectMaterial :visible.sync="selectVisible" @selectObj="selectObj"></selectMaterial>
	</el-dialog>
</template>

<script>
	import selectMaterial from './selectMaterial.vue'
	export default {
		components: {
			selectMaterial,
		},
		props: {
			type: {
				type: [Number, String],
				default: '',
			},
			visible: {
				type: Boolean,
				default: false,
			},
			row: {
				type: Object,
				default: () => {},
			},
			isOnlyRead: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				// dialogVisible: false,
				setObj: {},
				form: {
					title: '',
					content: '',
					material_json: {}
				},
				selectVisible: false,
				selection: [],
			};
		},
		computed: {
			dialogVisible: {
				get() {
					return this.visible
				},
				set(val) {
					this.$emit('update:visible', val)
				}
			},
			title() {
				return this.isOnlyRead ? '详情' : ( this.row && Object.keys(this.row).length ? '编辑话术' : '新增话术')
			}
		},
		watch: {
			visible(val) {
				if (val && this.row?.material?.length) {
					this.selection = [...this.row.material]
					this.form.title = this.row.title
					this.form.content = this.row.content
				}else if(val && !Object.keys(this.row).length){
					this.selection = []
					this.form.title = ''
					this.form.content = ''
				}
			}
		},
		methods: {
			handleClose(done) {
				if(this.isOnlyRead){
					done();
					this.$emit('update:visible', false)
					return
				}
				this.$confirm('确认？')
					.then(() => {
						done();
						this.$emit('update:visible', false)
					})
					.catch(() => {});
			},
			selectObj(obj) {
				this.selection = obj
			},
			handleDelete(deleteObj) {
				if(this.isOnlyRead) return
				this.selection = this.selection.filter((item) => item.id != deleteObj.id)
			},
			submit() {
				if (!this.selection?.length || !this.form.title || !this.form.content) {
					this.$message.error('请至少选择一个素材!');
					return
				}
				this.form.material_json = JSON.stringify(this.selection)
				this.$axios.post(this.$apis.addWording, this.form).then(res => {
					if (res.code == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						});
						this.form = {
							title: '',
							content: '',
							material_json: {}
						}
						this.$emit('getList')
						this.$emit('update:visible', false)
					} else {
						this.$message.error(res.msg);
					}
				})
			}
		},
		mounted() {}
	};
</script>

<style lang="scss" scoped>
	.item1 {
		display: flex;
		align-content: center;
		justify-content: space-between;
		padding: 5px;
		font-size: 12px;
		height: 35px;
		align-items: center;
		margin: 1px;
		border: 1px solid #dddddd;
		border-radius: 5px;
	}
</style>